import { Theme } from '@mui/material/styles';

export const radioControl = (theme: Theme) => ({
    marginY: theme.spacing(2),
    marginBottom: '0px',
}) as const;

export const radioWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
} as const;

export const label = {
    display:'flex',
    flexDirection: 'row-reverse',
    color: 'text.secondary',
    fontSize: 12,

    '&.Mui-focused': {
        color: 'text.secondary',
    },

    '&.Mui-error': {
        color: 'text.secondary',
    },

    '& .MuiFormLabel-asterisk': {
        '&.Mui-focused': {
            color: 'text.secondary',
        },

        '&.Mui-error': {
            color: 'text.secondary',
        },
    },
} as const;

export const optionLabel = (theme: Theme) => ({
    color: 'darkGray.main',

    '& .MuiFormControlLabel-label': {
        color: 'text.secondary',
        fontSize: 12,
        marginRight: theme.spacing(1),
    },

    '& .MuiRadio-root:not(.Mui-checked)': {
        '& svg': {
            color: 'darkGray.main',
        },
    },

    '& svg': {
        height: '20px',
        width: '20px',
    },
}) as const;

export const radio = (theme: Theme) => ({
    '&.Mui-disabled': {
        '& .MuiSvgIcon-root:nth-of-type(2)': {
            fill: theme.palette.darkGray.main,
            transform: 'scale(1.5)',
        },
    },
}) as const;

export const helperText = {
    marginX: 0,
    marginTop: 0,
} as const;
